import React, { useState, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import useMyTrainingApi from './config';
import { parseTableParams } from '../../utils/Utils';
import DataTable from '../../components/ui/DataTable';

const Container = styled.div``;

export default function MyTrainingsPage() {
  const { t } = useTranslation();
  const history = useHistory();

  const [queryParams, setQueryParams] = useState({ pageSize: 10, pageNumber: 1 });
  const [filterList, setFilterList] = useState([]);

  const { fetching, columns, data, pagination } = useMyTrainingApi(queryParams);

  const handleDataStateChange = useCallback((action, tableState) => {
    setFilterList(tableState.filterList);
    const params = parseTableParams(tableState, columns);
    setQueryParams(params);
  }, [columns]);

  const handleFilterConfirm = useCallback((newFilterList) => {
    setFilterList(newFilterList);
  }, []);

  const handleRowClick = useCallback((row) => {
    if (row?.assignmentId) {
      history.push(`/my-trainings/${row.assignmentId}`);
    }
  }, [history]);

  return (
    <Container>
      {useMemo(() => (
        <DataTable
          title={t('training.myTrainings')}
          fetching={fetching}
          columns={columns}
          data={data}
          totalRowCount={pagination.totalRowCount}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          filterList={filterList}
          onFilterConfirm={handleFilterConfirm}
          onTableChanged={handleDataStateChange}
          onRowClick={handleRowClick}
          customIdSelector="assignmentId"
        />
      ), [
        t, fetching, columns, data, pagination,
        filterList, handleFilterConfirm,
        handleDataStateChange, handleRowClick,
      ])}
    </Container>
  );
}
